module.exports = __webpack_public_path__ + "static/img/fail.e9aad90.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fail.svg
// module id = FPOz
// module chunks = 1 2